import { render } from "./StickyHeader.vue?vue&type=template&id=335e5a58"
import script from "./StickyHeader.vue?vue&type=script&lang=js"
export * from "./StickyHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__